import React from "react";
import { Link } from "react-router-dom";

// import use translation ------------------------------
import { useTranslation } from "react-i18next";
import { assetImages } from "constants";

const HomeBanner = () => {
  const { t } = useTranslation(); // translation marker

  return (
    <section
      className="banner_area"
      style={{ backgroundImage: `url(${assetImages.connectBannerDotsImg})` }}
    >
      <div className="container">
        <div className="banner_outer">
          <div className="row">
            <div className="col-lg-12">
              <div className="banner_content">
                <h1 style={{ fontSize: "5.5rem", lineHeight: "1.1" }}>
                  Podemos mejorar <br /> los resultados de tu
                  <br /> clínica
                </h1>
                <p>
                  Saludti junto a a sus partner del sector salud te ofrece
                  unirte a nuestro Ecosistema con: <br />
                  1. Central de Compras. <br />
                  2. Plataforma de Outsourcing. <br />
                  3. Servicios en Tecnología y Marketing y mucho más…
                </p>
                <div className="bnr_btns">
                  <Link
                    to="#"
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#register_mdl"
                  >
                    {t("Register now")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
